import Vue from 'vue';
import vuetify from '../../../../plugins/vuetify';
import templateMarkup from 'raw-loader!./alert-details-view.html';
import AlertDetails from '../../components/moi-details/alertDetails.vue';
import ko from "knockout";
import _ from "lodash";

const EDIT = 'edit';
const VIEW = 'view';

class AlertDetailView {
  constructor(params) {
    let self = this;
    self.route = params.route;
    self.myView = self.route().view;

    self.initializeAlertDetailsView();

    self.subscriptions = [
      self.route.subscribe(function () {
        // todo make sure you don't leave edit mode if things are not saved
        if (self.route().view === self.myView) {
          // self.initializeAlertDetailsView();
          if (self.vueAlertDetails) {
            self.extractRouteParams(self);

            self.mode = self.routeParams.id === 'new' || self.editParam ? EDIT : VIEW;

            let updated = self.vueAlertDetails.id !== self.routeParams.id
                || self.vueAlertDetails.mode !== self.mode
                || (self.routeParams.id === 'new' && (self.vueAlertDetails.type !== self.typeParam
                                                      || self.vueAlertDetails.category !== self.categoryParam
                                                      || self.vueAlertDetails.metric !== self.metricParam
                                                      || self.vueAlertDetails.groupBy !== self.groupByParam
                                                      || self.vueAlertDetails.title !== self.titleParam
                                                      || self.vueAlertDetails.next !== self.nextParam));

            self.vueAlertDetails.id = self.routeParams.id;
            self.vueAlertDetails.type = self.typeParam;
            self.vueAlertDetails.category = self.categoryParam;
            self.vueAlertDetails.metric = self.metricParam;
            self.vueAlertDetails.groupBy = self.groupByParam;
            self.vueAlertDetails.filter = JSON.parse(self.filterParam);
            self.vueAlertDetails.title = self.titleParam;
            self.vueAlertDetails.next = self.nextParam;
            self.vueAlertDetails.mode = self.mode;

            if (updated) self.vueAlertDetails.componentKey += 1;
          }
          // todo update here or subscribe in vue component
        }
      })
    ];

  }

  extractRouteParams(self) {
    self.routeParams = self.route();
    self.typeParam = _.get(self, 'routeParams["?query"].type', '');
    self.categoryParam = _.get(self, 'routeParams["?query"].category', '');
    self.metricParam = _.get(self, 'routeParams["?query"].metric', '');
    let gB = _.get(self, 'routeParams["?query"].groupBy', '');
    self.groupByParam = gB ? gB.split(',') : [];
    self.filterParam = window.sessionStorage.getItem('monitoringFilter');
    self.titleParam = _.get(self, 'routeParams["?query"].title', '');
    self.nextParam = _.get(self, 'routeParams["?query"].next', '');
    self.editParam = _.includes(_.get(self, 'routeParams["?query"][""]', []), 'edit');
  }

  initializeAlertDetailsView() {
    let self = this;
    self.extractRouteParams(self);
    self.ts = _.get(self, 'routeParams["?query"].ts', '0') * 1;
    self.group = JSON.parse(_.get(self, 'routeParams["?query"].group', '[]'));

    self.vueAlertDetails = new Vue({
      el: '#vueAlertDetails',
      vuetify,
      data: {
        componentKey: 0,
        id: self.routeParams.id,
        type: self.typeParam,
        category: self.categoryParam,
        metric: self.metricParam,
        groupBy: self.groupByParam,
        filter: JSON.parse(self.filterParam),
        title: self.titleParam,
        next: self.nextParam,
        mode: self.routeParams.id === 'new' || self.editParam ? EDIT : VIEW,
        ts: self.ts,
        group: self.group
      },
      components: {
        'alert-details': AlertDetails
      }
    });
  }

  dispose() {
    let self = this;
    _.forEach(self.subscriptions, function (subscription) {
      subscription.dispose();
    });
    if (self.vueAlertDetails) {
      self.vueAlertDetails.$destroy();
      self.vueAlertDetails.$el.parentNode.removeChild(self.vueAlertDetails.$el);
    }
  }

}

// this component is directly registered at 'src/app/component-registration.js'
// since it is needed long before its parent module is loaded
export default { template: templateMarkup, viewModel: AlertDetailView };
